// Translation for no
export const no = {
        common: {
            save: 'Lagre',
            cancel: 'Avbryt',
            close: 'Lukk',
            delete: 'Slett',
            edit: 'Rediger',
            activate: 'Aktiver',
            add: 'Legg til',
            saving: 'Lagrer...',
            loading: 'Laster...',
            active: 'AKTIV',
            inUse: 'I Bruk',
            test: 'Test',
            searchApps: 'Søk etter apper...',
            betaBanner: 'BETA - Tjeneste ikke tilgjengelig ennå!'
        },
        header: {
            creditBalance: 'Saldo',
            minutes: 'MIN'
        },
        auth: {
            signIn: 'Logg Inn',
            signUp: 'Registrer',
            username: 'Brukernavn',
            password: 'Passord',
            continue: 'Fortsett',
            noAccount: 'Har du ikke en konto?',
            hasAccount: 'Har du allerede en konto?',
            loginError: 'Innlogging mislyktes',
            invalidCredentials: 'Ugyldig brukernavn eller passord',
            rateLimited: 'For mange innloggingsforsøk. Vennligst vent et øyeblikk.',
            sessionExpired: 'Økten din er utløpt. Vennligst bruk en ny magisk lenke.',
            magicLinkInvalid: 'Innlogginglenken er ugyldig eller utløpt.',
            magicLinkSuccess: 'Velkommen! Du er blitt logget inn.',
            magicLinkProcessing: 'Behandler innlogging...',
            connectionError: 'Tilkoblingsfeil. Prøv igjen.'
        },
        profile: {
            myProgress: 'Min Læringsframgang',
            signOut: 'Logg Ut',
            plan: 'Plan: '
        },
        settings: {
            title: 'Innstillinger',
            tabs: {
                uiSettings: 'UI-innstillinger',
                systemPrompt: 'Systemprompt',
                llmProfiles: 'LLM-profiler',
                ttsProfiles: 'TTS-profiler',
                language: 'Språk',
            },
            uiSettings: {
                title: 'Brukergrensesnitt',
                themeMode: 'Temamodus',
                darkMode: 'Mørk Modus',
                lightMode: 'Lys Modus',
                themeColor: 'Temafarge',
                themeColorDesc: 'Velg aksentfarge for knapper, ikoner og uthevinger',
                background: 'Bakgrunn',
                backgroundDesc: 'Velg en bakgrunn for arbeidsrommet ditt',
                selectBackgroundColor: 'Velg Bakgrunnsfarge',
                backgrounds: {
                    cyberSchooling: 'Cyber Schooling',
                    focus: 'Fokus',
                    concentration: 'Konsentrasjon',
                    relaxation: 'Avslapping',
                    lianas: 'Lianer',
                    color: 'Farge'
                },
                backgroundColors: {
                    deepDark: 'Dypt Svart',
                    darkGrey: 'Mørk Grå',
                    midnightBlue: 'Midnattsblå',
                    indigo: 'Indigo',
                    darkTeal: 'Mørk Blågrønn',
                    brown: 'Brun',
                    darkRed: 'Mørk Rød',
                    deepPurple: 'Dypt Lilla',
                    pureWhite: 'Rent Hvitt',
                    softWhite: 'Mykt Hvitt',
                    lightGrey: 'Lys Grå',
                    paleBlue: 'Blek Blå',
                    paleGreen: 'Blek Grønn',
                    paleOrange: 'Blek Oransje',
                    lavender: 'Lavendel',
                    blueGrey: 'Blågrå'
                }
            },
            systemPrompt: {
                label: 'Systemprompt:',
                placeholder: 'Laster systemprompt...',
                emptyError: 'Systemprompt kan ikke være tom!',
                saveSuccess: '✓ Systemprompt lagret!',
                loadError: 'Feil ved lasting av systemprompt',
                saveError: 'Feil ved lagring'
            },
            llmProfiles: {
                addButton: '+ Legg Til Ny Tilkobling',
                newConnection: 'Ny Tilkobling',
                editConnection: 'Rediger Tilkobling',
                emptyState: 'Ingen LLM-tilkoblinger tilgjengelige. Klikk nedenfor for å legge til en.',
                loadingProfiles: 'Laster profiler...',
                nameLabel: 'Navn *',
                namePlaceholder: 'f.eks. OpenAI GPT-4',
                apiUrlLabel: 'API-URL *',
                apiUrlPlaceholder: 'https://api.openai.com/v1/chat/completions',
                apiKeyLabel: 'API-nøkkel *',
                apiKeyPlaceholder: 'sk-...',
                modelLabel: 'Modell *',
                modelPlaceholder: 'gpt-4, mistral-tiny, osv.',
                allFieldsRequired: 'Alle felt må fylles ut!',
                saveSuccess: '✓ Profil lagret!',
                deleteConfirm: 'Vil du virkelig slette "{name}"?',
                profileNotFound: 'Profil ikke funnet!',
                loadError: 'Feil ved lasting av profiler',
                saveError: 'Feil ved lagring',
                activateError: 'Feil ved aktivering',
                deleteError: 'Feil ved sletting',
                modelInfo: 'Modell: {model} | API: {api}'
            },
            ttsProfiles: {
                addButton: '+ Legg Til Ny Stemme',
                newVoice: 'Ny Stemme',
                editVoice: 'Rediger Stemme',
                emptyState: 'Ingen TTS-profiler tilgjengelige. Klikk nedenfor for å legge til en.',
                loadingProfiles: 'Laster TTS-profiler...',
                nameLabel: 'Navn',
                namePlaceholder: 'f.eks. Min ElevenLabs Adam',
                providerLabel: 'Leverandør',
                providerPlaceholder: 'f.eks. ElevenLabs, OpenAI, Piper',
                providerPiper: 'Piper (Lokalt)',
                providerOpenAI: 'OpenAI',
                providerElevenLabs: 'ElevenLabs',
                providerAzure: 'Azure',
                apiUrlLabel: 'API-URL *',
                apiUrlPlaceholder: 'https://api.example.com/tts',
                apiKeyLabel: 'API-nøkkel *',
                apiKeyPlaceholder: 'sk-...',
                modelIdLabel: 'Modell-ID *',
                modelIdPlaceholder: 'f.eks. eleven_monolingual_v1',
                voiceIdLabel: 'Stemme-ID',
                voiceIdPlaceholder: 'f.eks. pNInz6obpgDQGcFmaJgB',
                allFieldsRequired: 'Alle felt må fylles ut!',
                saveSuccess: '✓ TTS-profil lagret!',
                deleteConfirm: 'Vil du virkelig slette "{name}"?',
                loadError: 'Feil ved lasting av TTS-profiler',
                saveError: 'Feil ved lagring',
                activateError: 'Feil ved aktivering',
                deleteError: 'Feil ved sletting'
            },
            language: {
                title: 'Velg Språk',
                description: 'Velg ditt foretrukne språk for brukergrensesnittet'
            },
        },
        chat: {
            ready: 'Klar',
            start: 'START',
            stop: 'STOPP',
            initialMessage: 'Klikk START for sanntidssamtale.',
            listening: 'Lytter...',
            speaking: 'Thorsten taler...',
            userLabel: 'Du',
            aiLabel: 'AI',
            modalTitle: 'Thorsten AI Chat',
            inputPlaceholder: 'Skriv en melding...',
            send: 'Send',
            loginRequired: 'Logg inn for å bruke denne tjenesten.',
            loginButton: 'Logg Inn Nå',
            magicLinkRequired: 'Vennligst bruk en magisk lenke for innlogging.',
            creditLimitError: 'Timekontoen din er oppbrukt. Oppgrader planen din (Medium/Premium) for å fortsette.',
            serviceDisabled: 'Chat-tjenesten er for øyeblikket ikke tilgjengelig. Vennligst prøv igjen senere.'
        },
        notifications: {
            error: 'Feil',
            success: 'Suksess',
            info: 'Informasjon',
            unknownError: 'En ukjent feil oppstod'
        },
        cookie: {
            message: 'Dette nettstedet bruker cookies for å gi deg den beste mulige brukeropplevelsen.',
            accept: 'Godta'
        },
        curriculum: {
                buttonLabel: 'Læreplan',
                buttonTitle: 'Vis læreplaninnhold',
                modalTitle: '{app} Læreplan',
                sections: {
                    topic: 'Læreplanemne',
                    explanation: 'Barnevennlig forklaring',
                    studentProfile: 'Elevprofil'
                },
                topic: {
                    empty: 'Ingen læreplanemne er koblet til denne mikroappen i backend.',
                    missingDetail: 'Detaljerte læreplandata for denne mikroappen er ikke tilgjengelig i backend ennå.',
                    learningGoals: 'Læringsmål',
                    prerequisites: 'Forutsetninger',
                    unitLabel: 'Enhet',
                    durationLabel: 'Varighet',
                    difficultyLabel: 'Vanskelighetsgrad',
                    hours: 't',
                    minutes: 'min'
                },
                explanation: {
                    empty: 'Ingen barnevennlig forklaring tilgjengelig.',
                    loadingPrepare: 'AI forbereder forklaringen',
                    loadingExplain: 'AI forklarer emnet på barnevennlig språk',
                    requestFailed: 'Barnevennlig forklaring kunne ikke genereres.'
                },
                studentProfile: {
                    country: 'Land',
                    region: 'Stat / Region',
                    schoolType: 'Skoletype',
                    grade: 'Klassetrinn',
                    noContext: 'Ingen elevkontekst tilgjengelig.',
                    childProfileNotFound: 'Ingen elevprofil ble funnet i backend for gjeldende innlogging.',
                    loginProfileIncomplete: 'Innloggingsprofilen inneholder ennå ikke en fullstendig elevkontekst.',
                    educationContextNotFound: 'En elevprofil ble funnet, men ingen læreplantilknytning er satt.',
                    noToken: 'Ingen innlogget elev funnet.'
                },
                errors: {
                    signInRequired: 'Vennligst logg inn for å se læreplanen.',
                    appIdMissing: 'App-ID mangler.',
                    loadFailed: 'Kunne ikke laste læreplandata.'
                }
            }
    };
